export const club = {
  name: "IMANA ACADEMY",
  email: "imana.combat@yahoo.com",
  phones: [
    { label: "06 16 54 13 25", href: "tel:+33616541325" },
    { label: "06 26 95 14 25", href: "tel:+33626951425" },
  ],
  facebook: "https://www.facebook.com/groups/800110457055256/?locale=fr_FR",
  instagram: "https://www.instagram.com/imana_mma_academy/",
  snapchat: "https://www.snapchat.com/add/jjbevolution",
  description:
    "Club de MMA et Jiu-Jitsu Brésilien à Savigny-le-Temple 77176. Cours enfants et adultes, du loisir à la compétition.",
  nav: [
    { label: "Accueil", href: "#accueil" },
    { label: "Nos coachs", href: "coachs" },
    { label: "Planning", href: "#planning" },
    { label: "Tarifs", href: "pricing" },
  ],
  coaches: [
    {
      name: "Khofi",
      role: "Coach MMA & Grappling",
      image: "/images/coaches/ishaq.jpg",
      alt: "Khofi dans une salle d’entraînement de sports de combat",
      quote: "Au sol, chaque détail compte. On apprend à voir le jeu avant de le subir.",
      focus: "Garde · Soumissions · Contrôle",
    },
    {
      name: "Ishaq",
      role: "Coach MMA & Grappling",
      image: "/images/gallery/coach-training-session.jpg",
      alt: "Ishaq pendant un entraînement Imana Academy",
      quote: "La technique devient solide quand elle est répétée avec intention.",
      focus: "Technique · Contrôle · Progression",
    },
    {
      name: "Abdallah",
      role: "Coach Jiu-Jitsu Brésilien",
      image: "/images/coaches/abdallah.jpg",
      alt: "Abdallah pendant un entraînement de Jiu-Jitsu Brésilien",
      quote: "Le meilleur niveau est celui qui donne envie au groupe d'aller plus loin.",
      focus: "JJB · Stratégie · Compétition",
    },
  ],
};

export const schedule = [
  {
    discipline: "JJB",
    audience: "Kids · dès 6 ans et demi",
    sessions: [
      ["Lundi", "17h30 – 18h30", "Jean Zay"],
      ["Mercredi", "19h00 – 20h00", "Jean Zay"],
      ["Samedi", "14h00 – 15h00", "Léo Lagrange"],
      ["Dimanche", "13h00 – 14h15", "Jean Zay"],
    ],
  },
  {
    discipline: "JJB",
    audience: "Adultes 15 ans et +",
    sessions: [
      ["Lundi", "18h30 – 20h00", "Jean Zay"],
      ["Mercredi", "20h00 – 22h00", "Jean Zay"],
      ["Vendredi", "20h00 – 22h00", "Jean Zay"],
    ],
  },
  {
    discipline: "MMA",
    audience: "",
    sessions: [
      ["Lundi", "20h00 – 22h00", "Jean Zay"],
      ["Jeudi", "20h30 – 22h00", "Jean Zay"],
    ],
  },
  {
    discipline: "GRAPPLING",
    audience: "",
    sessions: [
      ["Jeudi", "19h00 – 20h30", "Jean Zay"],
      ["Vendredi", "19h00 – 20h30", "Jean Zay"],
    ],
  },
] as const;

export const locations = [
  {
    name: "Gymnase Jean Zay",
    address: "Av. Victor Schoelcher, 77176 Savigny-le-Temple",
    image: "/generated/venue-jean-zay.png",
    maps:
      "https://www.google.com/maps/dir/?api=1&destination=48.5852886,2.5847821&travelmode=driving",
  },
  {
    name: "Gymnase Léo Lagrange",
    address: "26 rue Elsa Triolet, 77176 Savigny-le-Temple",
    image: "/generated/venue-leo-lagrange.png",
    maps:
      "https://www.google.com/maps/dir/?api=1&destination=48.6052803,2.5781618&travelmode=driving",
  },
] as const;

export const gallery = [
  {
    src: "/images/gallery/champion-france.jpg",
    alt: "Combattant d’Imana Academy présentant ses médailles au championnat de France de Jiu-Jitsu Brésilien",
    width: 1080,
    height: 1080,
  },
  {
    src: "/images/gallery/club-training-session.jpg",
    alt: "Coach d’Imana Academy aux côtés d’une combattante après un entraînement de MMA",
    width: 1080,
    height: 1080,
  },
  {
    src: "/images/gallery/coach-training-session.jpg",
    alt: "Coach d’Imana Academy donnant des consignes pendant un entraînement",
    width: 1080,
    height: 1080,
  },
  {
    src: "/images/gallery/collective-combat-training.jpg",
    alt: "Combattant d’Imana Academy entouré de son équipe après une victoire de MMA",
    width: 867,
    height: 1138,
  },
  {
    src: "/images/gallery/prepa-ngannou.jpg",
    alt: "Francis Ngannou entouré de trois partenaires après une séance de préparation",
    width: 719,
    height: 719,
  },
  {
    src: "/images/gallery/miniaturefeminin.jpg",
    alt: "Mélissa Magalhaes en kimono devant un cours féminin de Jiu-Jitsu Brésilien",
    width: 1273,
    height: 618,
  },
];
